import React from 'react';
import PropTypes from 'prop-types';

import { formatMenuLabelText, isMenuLabelTruncated } from './menuLabelDisplay';
import styles from './OrganizationDropdown.module.css';

export const DropdownSection = ({ title, children, showDividerBelow = false }) => (
  <div className={styles.section}>
    {title ? (
      <div
        className={styles.sectionHeading}
        title={isMenuLabelTruncated(title) ? title : undefined}>
        {formatMenuLabelText(title)}
      </div>
    ) : null}
    {children}
    {showDividerBelow ? <div className={styles.sectionDivider} /> : null}
  </div>
);

DropdownSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  showDividerBelow: PropTypes.bool,
};
